import { useSuspenseQuery } from "@tanstack/react-query";
import {
	createFileRoute,
	useNavigate,
	useParams,
	useSearch,
} from "@tanstack/react-router";
import { Button } from "@/components/base/buttons/button";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { organizationQueryOptions } from "@/services/organization";
import { SearchSchema } from "../$subOrgId";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-organizations/(sub-orgs)/$subOrgId/",
)({
	component: IndexComponent,
	validateSearch: (search) => {
		return SearchSchema.parse(search);
	},
});

function IndexComponent() {
	const { t } = useAppTranslation();
	const navigate = useNavigate();
	const params = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-organizations/(sub-orgs)/$subOrgId/",
	});
	const search = useSearch({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-organizations/(sub-orgs)/$subOrgId/",
	});

	const subOrganizationById = useSuspenseQuery(
		organizationQueryOptions.subOrganizations.detail(
			params.orgId,
			params.subOrgId,
		),
	);

	const isViewMode = search.mode === "view";

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<div>
					<h3 className="text-lg font-semibold text-gray-900">
						{t("org-admin.sub-organizations.tabs.details.title")}
					</h3>
					<p className="text-sm text-gray-600">
						{t("org-admin.sub-organizations.drawer.description")}
					</p>
				</div>
				{isViewMode && (
					<Button
						color="primary"
						onClick={() => {
							navigate({
								to: "/org-admin/$orgId/sub-organizations/$subOrgId/details",
								params: { orgId: params.orgId, subOrgId: params.subOrgId },
								search: { mode: "edit" },
							});
						}}
					>
						{t("common.actions.edit")}
					</Button>
				)}
			</div>
			<div className="bg-white rounded-lg border border-gray-200 p-6">
				{subOrganizationById.isLoading ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-gray-500">
							{t("common.actions.loading")}
						</div>
					</div>
				) : subOrganizationById.error ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-red-500">
							{t("common.actions.errorLoading")}
						</div>
					</div>
				) : (
					<div>{t("org-admin.sub-organizations.tabs.details.title")}</div>
				)}
			</div>
			{!isViewMode && (
				<div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
					<Button
						onClick={() => {
							navigate({
								to: "/org-admin/$orgId/sub-organizations/$subOrgId/details",
								params: { orgId: params.orgId, subOrgId: params.subOrgId },
								search: { mode: "view" },
							});
						}}
					>
						{t("common.actions.cancel")}
					</Button>
				</div>
			)}
		</div>
	);
}
